import type { ControlledPOSTDto } from 'src/Libs/flow/installation/api'
import type { ModbusTcpChargingStation } from 'src/Libs/flow/installation/forms'
import { wittyLinkReference } from '../../../../wallboxes/models/wallbox-reference'

/** Is false if fallbackMaxCurrent is 0, true otherwise. Note: It's always false for EEbus. */
export const getChargeInFallbackModeAllowed = (fallbackMaxCurrent: ModbusTcpChargingStation['fallbackMaxCurrent']): boolean => {
  return (fallbackMaxCurrent || 0) > 0
}

export const getMidMeterParameters = (modbusTcp: ModbusTcpChargingStation): Pick<ControlledPOSTDto['parameters'], 'useMidMeter' | 'pulseWeight'> => {
  // Witty link always uses mid meter.
  if (modbusTcp.reference === wittyLinkReference) {
    return {
      useMidMeter: true,
      pulseWeight: 0,
    }
  }

  const midMeter = modbusTcp.midMeter

  if (midMeter === 'ECP140D') {
    return {
      useMidMeter: true,
      pulseWeight: 1,
    }
  }

  if (midMeter === 'ECP380D') {
    return {
      useMidMeter: true,
      pulseWeight: 5,
    }
  }

  return {
    useMidMeter: false,
    pulseWeight: 0,
  }
}
